/**
/**
 * A checkbox component with optional server synchronization.
 *
 * @component
 * @param {Object} props - The component props
 * @param {string} props.label - The label text to display next to checkbox
 * @param {boolean} props.value - The current checked state of checkbox
 * @param {Function} props.setValue - Callback function to update checkbox state
 * @param {string} [props.url] - Optional URL endpoint for server synchronization
 * @param {string} [props.field] - Optional field name for server data
 * @param {Object} [props.style={}] - Optional CSS styles to apply to container
 * @returns {JSX.Element} A checkbox with label in a flex container
 *
 * @author Forge
 * @date 2026-04-03
 * @version 2.0.0 - Updated to use CustomCheckbox
 */
import CustomCheckbox from "./CustomCheckbox";
import mut from "../hooks/mut";


export default function CheckBox({label, value, setValue, url, field, style={}}) {
    const change = async (checked) => {
        setValue(checked);
        if (url && field) {
            await mut("post",url, { [field]: checked });
        }
    }

    return (<CustomCheckbox label={label} checked={value} onChange={change} url={url} field={field} style={style} />)
}